import { Component } from '@angular/core';

import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'cstmr-footer',
  imports: [DividerModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  date: number = new Date().getFullYear();
}
